import { render, staticRenderFns } from "./EntityModal.vue?vue&type=template&id=1bd441d2&scoped=true&"
import script from "./EntityModal.vue?vue&type=script&lang=ts&"
export * from "./EntityModal.vue?vue&type=script&lang=ts&"
import style0 from "./EntityModal.vue?vue&type=style&index=0&id=1bd441d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd441d2",
  null
  
)

export default component.exports